import { render, staticRenderFns } from "./ReservationsDataTable.vue?vue&type=template&id=1926d3ca&lang=pug&"
import script from "./ReservationsDataTable.vue?vue&type=script&lang=js&"
export * from "./ReservationsDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ReservationsDataTable.vue?vue&type=style&index=0&id=1926d3ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports